<sick-instance-info
  *ngFor="let instance of instances"
  [instance]="instance"
  [redirecting]="redirecting"
  (stopTimerClick)="stopTimer()"
  (startInstanceClick)="startInstance(instance)"
></sick-instance-info>
